import React from 'react'
import PropTypes from 'prop-types'
import * as styles from './styles'

const propTypes = {
  metrics: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  }))
}

const defaultProps = {
  metrics: [
    { value: '<200ms', label: 'Query latency' },
    { value: '99.9%', label: 'Uptime SLA' },
    { value: '10M+', label: 'Predictions/day' }
  ]
}

const MetricsPills = ({ metrics }) => {
  return (
    <styles.Container>
      {metrics.map((metric, index) => (
        <styles.Pill key={index}>
          <styles.Value>{metric.value}</styles.Value>
          <styles.Label>{metric.label}</styles.Label>
        </styles.Pill>
      ))}
    </styles.Container>
  )
}

MetricsPills.propTypes = propTypes
MetricsPills.defaultProps = defaultProps

export default MetricsPills